const QUESTIONNAIRE_INDEX = "questionnaireIndex";

const useQuestionnaireIndex = () => {
  const writeIndex = (index: number) => {
    localStorage.setItem(QUESTIONNAIRE_INDEX, index.toString());
  };

  const readIndex = (): number | null => {
    return JSON.parse(localStorage.getItem(QUESTIONNAIRE_INDEX) || "null");
  };

  const clearIndex = () => {
    localStorage.removeItem(QUESTIONNAIRE_INDEX);
  };

  return { writeIndex, readIndex, clearIndex };
};

export default useQuestionnaireIndex;
